import { useCallback, useEffect, useState } from 'react'
import { twinFetchPostJSON } from '../../../../../../utils/globals/data'
import { setVariablesToCurrentPage } from '../../../../../../utils/reducers/reduxDispatch'
import { ComponentTabObject } from '../../../../../../utils/hooks/useTabLogic'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import { getBasePath } from '../../../../../../utils/globals/link'
import EditCardTabs from '../../../../../../baseComponents/EditCardTabs'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { useParams } from 'react-router'
import { useLocation } from 'react-router'
import { SupplierModelType } from '@teinor/erp/types/company/supplier'
import MainSupplierProfile from './Tabs/MainSupplierProfile'
import SupplierContactPersons from './Tabs/SupplierContactsPersons'
import SupplierNotes from './Tabs/SupplierNotes'
import SupplierServices from './Tabs/SupplierServices'
import SupplierFiles from './Tabs/SupplierFiles'
import SupplierBanks from './Tabs/SupplierBanks'
import SupplierTradeAgreements from './Tabs/SupplierTradeAgreements'
import SupplierBillingGroups from './Tabs/SupplierBillingGroups'


type SingleSupplierProps = SingleSupplierLogicProps & ComponentWithPermissions & {}

const SingleSupplier: React.FC<SingleSupplierProps> = ({ userPermissions }) => {
    const location = useLocation()
    const params = useParams<{ id: string, tab?: string }>()
    const { t } = useTwinTranslation()
    const { basicData, getData } = useSingleSupplierLogic({ params })
    if (!params.id) {
        return null
    }
    const tabs: ComponentTabObject = {
        'main': { component: MainSupplierProfile, text: t('general', 'General'), permission: 'supplier.main' },
        'trade-agreements': { component: SupplierTradeAgreements, text: t('tradeAgreements', 'Acuerdos comerciales'), permission: 'supplier.tradeAgreements' },
        'contacts-persons': { component: SupplierContactPersons, text: t('people', 'Personas'), permission: 'supplier.contactPersons' },
        'bank': { component: SupplierBanks, text: t('banks', 'Bancos'), permission: 'supplier.bank' },
        'service': { component: SupplierServices, text: t('services', 'Servicios'), permission: 'supplier.service' },
        'notes': { component: SupplierNotes, text: t('notes', 'Notas'), permission: 'supplier.main' },
        'billingGroups': { component: SupplierBillingGroups, text: t('billingGroups', 'Grupos de facturación'), permission: 'supplier.billingGroup' },
        'files': { component: SupplierFiles, text: t('files', 'Ficheros'), permission: 'supplier.files' }
    }

    return (<EditCardTabs basePath={getBasePath(location.pathname, params.id)} basicData={basicData} tabs={tabs} tab={params.tab} userPermissions={userPermissions} getData={getData} />)
}

interface SingleSupplierLogicProps {
    params: { id?: string, tab?: string }
}

const useSingleSupplierLogic = ({ params }: SingleSupplierLogicProps) => {
    const [basicData, setBasicData] = useState<SupplierModelType | null>(null)

    const id = params.id

    const getData = useCallback(async () => {
        const myData: SupplierModelType = await twinFetchPostJSON('/api/app/supplier/getSupplierInstance', {
            id
        })
        if (myData) {
            setBasicData(myData)
            setVariablesToCurrentPage([myData.name])
        }
    }, [setBasicData, id])

    useEffect(() => {
        getData()
    }, [getData])

    return { basicData, getData }
}

export default SingleSupplier